import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import showObject from '../../../utils/showObject';
import imageModifier from '../../../utils/imageModifier';
import formatBytes from '../../../utils/formatBytes';

const TYPE_ICONS = {
  video: 'icon-video-file',
  audio: 'icon-music-file',
  file: 'icon-file',
};

const MamAssetCard = (props) => {
  const {
    obj, onOpen, small,
  } = props;
  const {
    assetSlugName, isPublic, fileReadableName, url, fileExtension, type, createdAt, fileSize,
  } = obj;

  const [objectUrl, setObjectUrl] = useState();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isPublic) {
      showObject(`${assetSlugName}`, fileExtension, true).then(res => setObjectUrl(res));
    } else {
      setObjectUrl(url);
    }
  }, [assetSlugName, isPublic, url]);

  const title = (fileReadableName && fileReadableName.en) || assetSlugName;
  const date = createdAt && Number(createdAt) ? new Date(Number(createdAt)).toISOString().slice(0, 10) : '';
  const size = formatBytes(fileSize);
  const meta = [date, size].filter(Boolean).join(' · ');
  const sizeClass = small ? 'w-80px' : 'w-110px';
  const thumbClass = small ? 'h-80px w-80px' : 'h-110px w-110px';

  const copyUrl = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(objectUrl || url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    });
  };

  return (
    <div className={`${sizeClass} mx-8px mb-4 cursor-pointer`} onClick={() => onOpen(assetSlugName)}>
      <div className={`${thumbClass} relative rounded overflow-hidden bg-black flex items-center justify-center mamCardThumb`}>
        {type === 'image' && (
          fileExtension !== 'svg'
            ? <img src={imageModifier(objectUrl, '200x200')} className={`${thumbClass} object-cover`} alt={title} />
            : <img src={objectUrl} className={`${thumbClass} object-cover`} alt={title} />
        )}
        {type !== 'image' && <span className={`font-icon ${TYPE_ICONS[type] || 'icon-file'} text-4xl text-white`} />}
        {!isPublic && <span title="Private" className="absolute w-3 h-3 rounded-full bg-red border border-white mamDotPrivate" style={{ top: '4px', right: '4px' }} />}
        <span className="absolute bg-black text-white text-xxs px-1 rounded-sm uppercase" style={{ top: '4px', left: '4px', opacity: 0.75 }}>{fileExtension}</span>
        <button
          type="button"
          onClick={copyUrl}
          className="absolute bg-white text-black text-xxs px-1 rounded-sm font-americaMonoBold mamCopyBtn"
          style={{ bottom: '4px', right: '4px' }}
        >
          {copied ? 'copied!' : 'copy url'}
        </button>
      </div>
      <p className="text-10 font-americaMonoRegular mt-1 mb-0 break-all leading-tight mamCardTitle">{title}</p>
      {meta && <p className="text-xxs text-grey m-0">{meta}</p>}
    </div>
  );
};

MamAssetCard.propTypes = {
  obj: PropTypes.shape({
    assetSlugName: PropTypes.string.isRequired,
    isPublic: PropTypes.bool,
    fileReadableName: PropTypes.shape({ en: PropTypes.string }),
    url: PropTypes.string,
    fileExtension: PropTypes.string,
    type: PropTypes.string,
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fileSize: PropTypes.number,
  }).isRequired,
  onOpen: PropTypes.func.isRequired,
  small: PropTypes.bool,
};

MamAssetCard.defaultProps = {
  small: false,
};

export default MamAssetCard;
